export enum MachinePackageCacheRetentionUnit {
    Items = "Items"
}
export enum MachinePackageCacheRetentionStrategy {
    Default = "Default",
    Quantities = "Quantities",
    FreeSpace = "FreeSpace"
}
const DefaultStrategy: DefaultMachinePackageCacheRetentionPolicy = {
    Strategy: MachinePackageCacheRetentionStrategy.Default,
    QuantityOfVersionsToKeep: null,
    VersionUnit: null,
    QuantityOfPackagesToKeep: null,
    PackageUnit: null,
};
export const MachinePackageCacheConstants = {
    KeepAll: -1,
    MinPackagesToKeep: 1,
    MinVersionsToKeep: 1,
    DefaultPackagesToKeep: 30,
    DefaultVersionsToKeep: 2,
    DefaultStrategy: DefaultStrategy,
};
export type MachinePackageCacheRetentionPolicy = DefaultMachinePackageCacheRetentionPolicy | QuantitiesMachinePackageCacheRetentionPolicy;
export interface DefaultMachinePackageCacheRetentionPolicy {
    Strategy: MachinePackageCacheRetentionStrategy.Default;
    QuantityOfVersionsToKeep: null;
    VersionUnit: null;
    QuantityOfPackagesToKeep: null;
    PackageUnit: null;
}
export interface QuantitiesMachinePackageCacheRetentionPolicy {
    Strategy: MachinePackageCacheRetentionStrategy.Quantities;
    QuantityOfVersionsToKeep: number;
    VersionUnit: MachinePackageCacheRetentionUnit;
    QuantityOfPackagesToKeep: number;
    PackageUnit: MachinePackageCacheRetentionUnit;
}
